import {Component, EventEmitter, Input, OnChanges, Output, OnInit} from '@angular/core';
import {Education} from '../../../models/customer.model';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { EducationService } from 'app/services/education/education.service';

@Component({
  selector: 'kv-education-form',
  templateUrl: 'educationForm.html',
  styles: ['label.required:after {top: 0}']
})

export class EducationFormComponent implements OnChanges, OnInit {
  @Output() educationAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() educationUpdated: EventEmitter<any> = new EventEmitter<any>();
  @Input() dialogBoxEducation: Education;
  addEditForm: FormGroup;
  fields: any;
  invalidSubmit: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private educationSvc: EducationService) {
  }

  ngOnChanges(...args: any[]) {
    this.addEditForm = this.formBuilder.group({
      'title': new FormControl(this.dialogBoxEducation.title, Validators.compose([Validators.required, Validators.maxLength(255)])),
      'description': new FormControl(this.dialogBoxEducation.description, Validators.compose([Validators.required, Validators.maxLength(255)]))
    });
  }

  ngOnInit() {
    this.educationSvc.getFields().subscribe(res => {
      this.fields = res;
    });
  }

  saveOrUpdate(dialogBoxEducation): void {
    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;
    let newData = Object.assign({}, this.dialogBoxEducation, this.addEditForm.value);
    if (newData.id == null) {
      this.educationAdded.emit(newData);
    } else {
      this.educationUpdated.emit(newData);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/education/educationForm.component.ts